var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["instagram-feed", "instagram-feed--" + this.profile] },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "instagram-feed__items" },
        [
          _vm._l(_vm.feed, function(item, index) {
            return index < _vm.pageLoads * _vm.count
              ? _vm._t(
                  "feed",
                  [
                    _c(
                      "div",
                      {
                        key: index,
                        staticClass: "instagram-feed__item",
                        class: _vm.itemClass(item.type)
                      },
                      [
                        _c(
                          "div",
                          { key: index, staticClass: "instagram-feed__image" },
                          [
                            _c(
                              "a",
                              { attrs: { href: item.link, target: "_blank" } },
                              [
                                _c("div", {
                                  staticClass: "image-container",
                                  style: _vm.imageStyle(
                                    item.images.thumbnail.url
                                  )
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  { index: index, item: item }
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.moreData && _vm.displayLoadMore
        ? _c("div", { staticClass: "load-more-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "load-more",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("Load More")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/InstagramFeed.vue?vue&type=template&id=17361328&
// module id = 127
// module chunks = 7